import { OfficialData } from "../networkRequest/officialsService";
import { jwtDecode } from "jwt-decode";
import { FEATURE_FLAGS, ROLES } from '../constants';
import { Config } from './config';
import { isFeatureFlagEnabled } from './featureFlagUtils';

export const adminDashboardRoles = [ROLES.ADMIN, ROLES.OWNER, ROLES.SUPER_ADMIN];
export const agencyInfoEditRoles = [ROLES.OWNER, ROLES.SUPER_ADMIN];
export const surepassAdminDashboardRoles = [ROLES.SUPER_ADMIN];
export const verificationRoles = [ROLES.VERIFICATION_SPECIALIST, ROLES.AGENCY_VERIFIER];
export const sharePinRoles = [ROLES.SUPER_ADMIN]
export const credentialManagementRoles = [ROLES.ADMIN, ROLES.OWNER, ROLES.SUPER_ADMIN];
export const crossAgencyVerificationRoles = [ROLES.SUPER_ADMIN, ROLES.VERIFICATION_SPECIALIST];
export const searchAllOfficialsRoles = [ROLES.SUPER_ADMIN, ROLES.VERIFICATION_SPECIALIST];

// ideally this function can be used to determine if a user can interacte / see certain components such as the 'edit agency domain' button
// but also can be used to check authorization for accessing certain routes.
export const checkUserAuthorized = (userProfile: OfficialData, allowedRoles: string[]) => {
  const canAccessByRole = allowedRoles.includes(userProfile.role.name);
  const canAccessByStatus = userProfile.status === 'active';

  return canAccessByRole && canAccessByStatus;
}

// Whether the current user may assign the given role to an agency official
export const isRoleAssignable = (roleName: string, userProfile: OfficialData | undefined) => {
  if (roleName !== ROLES.AGENCY_VERIFIER) return true;
  return !Config.AGENCY_VERIFIER_ROLE_DISABLED && isFeatureFlagEnabled(userProfile, FEATURE_FLAGS.VERIFICATIONS);
}

export const checkTokenExpired = (token) => {
  try {
    const expiration = jwtDecode(token).exp;
    if (!expiration) throw new Error('There was an issue with the token. Try refreshing your browser.');
    const paddingTime = 60; // if it's close to expiring, let's just get a new one.

    return { expired: Math.floor(Date.now() / 1000) >= expiration - paddingTime, error: null }
  } catch(error: any) {
    return { expired: true, error: error.message}
  }
}